import { Link } from "react-router-dom";
import { navbarData } from "../../utils/consts";
import { useEffect, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
const Sidebar = ({ user }) => {
  const [sidebar, setSidebar] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 768) {
      setSidebar(true);
    }
  }, []);

  return (
    <div className="shrink-0">
      <div className="w-full md:hidden bg-white">
        <div className="mx-auto max-w-7xl w-full px-3 py-3 flex items-center justify-between">
          <Link to={"/main"}>
            <a href="javascript:void(0)">
              <img src="/incubation.png" className="w-24" />
            </a>
          </Link>

          <button
            className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
            onClick={() => setSidebar(!sidebar)}
          >
            {sidebar ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div
        className={`bg-white z-20 h-screen fixed left-0 top-0 md:sticky p-3 overflow-y-auto ${
          sidebar ? "block" : "hidden"
        }  w-[200px] shrink-0 md:w-[250px]`}
      >
        <Link to={"/main"}>
          <a
            href="javascript:void(0)"
            className="flex w-full items-center justify-center"
          >
            <img src="/incubation.png" className="max-w-[160px] flex-1" />
          </a>
        </Link>

        <ul className="flex flex-col py-5 gap-1">
          {user &&
            navbarData.map((item, index) => {
              if (item.role.includes(user?.role)) {
                return (
                  <li
                    key={index}
                    className={
                      "text-gray-600 text-sm lg:text-base  font-medium hover:text-primary hover:shadow-sx hover:shadow-[#0000003c] transition-all duration-500 border-b-[1px]"
                    }
                  >
                    {item?.name == "Chiqish" ? (
                      <Link
                        onClick={() => localStorage.removeItem("token")}
                        className="p-3 flex items-center bg-red-500 rounded-md mt-2"
                        to={item.url}
                      >
                        {/* <p>{item?.}</p> */}
                        <div className="mr-2">{item?.icon}</div>
                        <a
                          href="javascript:void(0)"
                          className="text-white text-[14px]"
                        >
                          {item.name ? item.name : "Profil"}
                        </a>
                      </Link>
                    ) : (
                      <Link className="p-3 flex items-center" to={item.url}>
                        {/* <p>{item?.}</p> */}
                        <div className="mr-2">{item?.icon}</div>
                        <a href="javascript:void(0)" className="text-[14px]">
                          {item.name ? item.name : "Profil"}
                        </a>
                      </Link>
                    )}
                  </li>
                );
              }
            })}
        </ul>
      </div>
      <div
        className={`${
          sidebar ? "block" : "hidden"
        } md:hidden z-10 fixed top-0 right-0 w-screen h-screen bg-[#00000052]`}
        onClick={() => {
          setSidebar(false);
        }}
      ></div>
    </div>
  );
};

export default Sidebar;
